export const it_operation = {
    title: 'Mercato Libero',
    title_current_operation: 'Operazioni',
    body: 'Se sei già un investitore esperto questa sezione ti aiuterà a determinare velocemente lo street price e il <b>ROI.</b>',
    button: 'Crea e Gestisci',
    title_card: 'Operazione',
    overview_label_value: 'Prezzo',
    overview_label_mq: 'Mq',
    overview_label_deviation: 'SCOSTAMENTO',
    overview_label_roi: 'ROI',
    title_star: 'Contrassegna',
    title_content: 'Contrassegna questa operazione come "In Corso"',
    title_content_starred: 'Operazione in corso.',
    title_content_closed: 'Operazione conclusa.',
    table_starred_start_date: 'Aperta',
    table_starred_closed_date: 'Chiusa',
    table_starred_address: 'Via',
    table_starred_city: 'Città',
    table_starred_roi: 'ROI',
    table_starred_roe: 'ROE',
    table_starred_profit: 'Profitto',
    title_trash:'Cestino',
    table_trash_restore:'Ripristino',
    trash_info:'In questa sezione puoi ripristinare gli immobili cancellati cliccando sul pulsante di Ripristino',
    modal_risorsa:'Nuova risorsa',
    trash_disclaimer:'Questi immobili resteranno nel cestino per 120 giorni, poi verranno definitivamente eliminati',
    popover_myOperation_title: 'Le tue operazioni',
    popover_myOperation_content: '<p>In questa card puoi visionare e gestire l’elenco delle operazioni in corso e concluse per le aste immobiliari. \n' +
        '<br><br>Cliccando sull’icona <i class="fas fa-pencil-alt  abtg__fontIcon"></i> puoi entrare nella scheda dell’operazione e modificare i dati relativi.</p>\n',

        data_importazione: 'data importazione',
        data_cancellazione: 'data cancellazione',
        in_corso:'in corso',
        conclusa:'conclusa',
        modifica:'modifica',
        nuovo:'nuovo',

};